import { GET_USER, RESET_USER } from "../actionTypes";

const userReducer = (state = null, action) => {
  switch (action.type) {
    case GET_USER:
      return action.payload;

    case RESET_USER:
      return state;

    default:
      return state;
  }
};

export default userReducer;
